module.exports = __webpack_public_path__ + "img/advantage4.ee4c883f.svg";